<template>
<span>
  <template v-for="(item, i) in data">
    <el-submenu :index="item.url" :key="i" v-if="item.children && nodeVisible(item)">
      <template slot="title">
        <i :class="'icon ' + item.icon"></i>
        <span>{{ item.name }}</span>
      </template>
      <ui-menu-tree :data="item.children"></ui-menu-tree>
    </el-submenu>
    <el-menu-item
      v-else-if="!item.children && nodeVisible(item)"
      :index="item.url"
      :key="'child' + i"
      class="light-color">
      <template slot="title">
        <i v-if="item.icon" :class="'icon ' + item.icon"></i>
        <span>{{ item.name }}</span>
      </template>
    </el-menu-item>
  </template>
</span>
</template>

<style scoped>
  .icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: contain;
    margin: 0 8px;
  } 
  .icon + span {
    vertical-align: middle;
  }
  .light-color {
    color: #BBBDCE;
  }
  .el-menu-item.is-active {
    /* color: #fff;
    background: linear-gradient(45deg, #4F8AFF 0%, #4B5EFF 100%);
    border-radius: 8px; */
    color: #4F8AFF;
    background-color: rgba(79, 138, 255, 0.125);
  }
</style> 
<script>
import { getRoletype } from '@/utils/getUser' 
import { isMenuVisible } from '@/utils/menuPermission'
export default {
  name: 'UiMenuTree',
  props: {
    data: Array
  },
  data () {
    return {
      roleName: '',
      roleType: null, // 添加 roleType 状态
      accountId: '' // 供报单汇总等账号特例判断
    }
  },
  computed: {
    isGLY () {
      return this.roleName.includes('管理员')
    },
    switchConfig () {
      let config = {}
      let switchConfigStr = sessionStorage.getItem('SWITCH_CONFIG')
      if (switchConfigStr) {
        let switchConfig = JSON.parse(switchConfigStr)
        for (let i = 0; i < switchConfig.length; i++) {
          config[switchConfig[i].switchType] = switchConfig[i].switchState
        }
        return config
      }
      return config
    }
  },
  created() {
    let accountDto = localStorage.getItem('ACCOUNT_DTO')
    if (accountDto) {
      accountDto = JSON.parse(accountDto)
      this.roleName = accountDto.accountRoleDto ? accountDto.accountRoleDto.roleName : ''
      this.roleType = accountDto.roleType || null
      this.accountId = accountDto.id || ''
    }
    
    // 如果 roleType 还未加载，等待加载
    if (!this.roleType) {
      this.waitForRoleType()
    }
  },
  methods: {
    /**
     * 等待 roleType 加载完成
     */
    async waitForRoleType() {
      const maxAttempts = 30 // 最多等待 3 秒
      let attempts = 0
      
      const check = () => {
        const roleType = getRoletype()
        if (roleType) {
          this.roleType = roleType
          return true
        }
        return false
      }
      
      const intervalId = setInterval(() => {
        attempts++
        if (check() || attempts >= maxAttempts) {
          clearInterval(intervalId)
          if (!this.roleType) {
            this.roleType = getRoletype() || 0
          }
        }
      }, 100)
    },
    nodeVisible (item) {
      // roleType 未加载完成时，隐藏所有需要权限判断的菜单
      if (!this.roleType) {
        return false
      }
      
      return isMenuVisible(item, this.roleType, this.accountId)
    }
  }
}
</script> 
